import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { PriceDisplayStyled } from './PriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
const mockCalculatedPriceSubTermWithPriceBreakdownForFree = {
  fullPrice: 0,
  calculatedPrice: 0
};
const mockQuantityPackPurchaseOptionForFree = {
  monthly: mockCalculatedPriceSubTermWithPriceBreakdownForFree,
  annually: mockCalculatedPriceSubTermWithPriceBreakdownForFree,
  offerInfo: {
    commitment: 'monthly',
    payment: 'monthly',
    discount: 0
  }
};
const HighlightedFreePriceDisplay = () => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  return /*#__PURE__*/_jsx(PriceDisplayStyled, {
    pricingInfo: mockQuantityPackPurchaseOptionForFree,
    showPricePerMonthPerSeat: false,
    seleniumId: "free-highlighted-price-per-month",
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};
export default HighlightedFreePriceDisplay;